import { useEffect, useState, useMemo } from 'react'; // Добавили useMemo
import './App.css';
import MyIngredients from './MyIngredients';
import MyList from './MyList';
import { v4 as uuid } from 'uuid';

function App() {
  // Используем ленивую инициализацию для чистоты
  const [mealPlans, setMealPlans] = useState(() => {
    return localStorage.mealPlans ? JSON.parse(localStorage.mealPlans) : [];
  });
  
  // Привели к одному названию стейта
  const [selectedDayId, setSelectedDayId] = useState(null);

  useEffect(() => {
    localStorage.setItem("mealPlans", JSON.stringify(mealPlans));
  }, [mealPlans]);

  const addMeal = () => {
    const newMeal = {
      id: uuid(),
      title: "Today is ....",
      mealForDay: "",
      ingredients: ""
    };
    setMealPlans([newMeal, ...mealPlans]);
    setSelectedDayId(newMeal.id); // Сразу выбираем новый день
  };

  const deleteDay = (mealId) => {
    setMealPlans(prev => prev.filter(({ id }) => id !== mealId));
    if (mealId === selectedDayId) {
      setSelectedDayId(null);
    }
  };

  const updateDay = (updatedMeal) => {
    setMealPlans(prev => prev.map(meal => 
      meal.id === updatedMeal.id ? updatedMeal : meal
    ));
  };

  // Это переменная, хранящая объект выбранного дня
  const activeMeal = useMemo(() => {
    return mealPlans.find(({ id }) => id === selectedDayId);
  }, [mealPlans, selectedDayId]);

  return (
    <div className='App'>
      <MyList 
        mealPlans={mealPlans} 
        addMeal={addMeal} 
        deleteDay={deleteDay}
        selectedDay={selectedDayId}
        setSelectedDay={setSelectedDayId}
      />
      
      {/* Исправленный тернарный оператор */}
      {activeMeal ? (
        <MyIngredients selectedDay={activeMeal} updateDay={updateDay}/>
      ) : (
        <div className="placeholder">Select a day from the list on the left</div>
      )}
    </div>
  );
}

export default App;

